import * as client from "../../services/client";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { selectAuthenticatedUser } from "../../store/selectors/auth";

import { selectAnnouncementFormData } from "../../store/selectors/AnnouncementForm";
import {
  setAnnouncementFormData,
  clearAnnouncementFormData,
} from "../../store/actions/AnnouncementForm";
import Button from "../Button";
import Col from "../Col";
import Form, { Heading } from "../Form";
import Input from "../Input";
import File from "../File";
import Row from "../Row";
import Loader from "../Loader";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import { selectValidation } from "../../store/selectors/Validation";
import { clearValidation } from "../../store/actions/validation";
import { stopFormLoading } from "../../store/actions/loader";
import Icon from "../Icon";
import Select from "../Select";
import { selectProperties } from "../../store/selectors/properties";
import { Multiselect } from "multiselect-react-dropdown";
import { fetchProperties } from "../../store/actions/properties";
// import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
// import draftToHtml from 'draftjs-to-html';
import TextEditor from "../Editor/Editor";
import { convertHTMLToString } from "../../helpers/validationHelper";
import Checkbox from "../Checkbox";
import { onCheckHeicDocument } from "../../helpers/CommonHelpers";



const floorOptions = [
  { id: 1, name: "Level 1" },
  { id: 2, name: "Level 2" },
  { id: 3, name: "Level 3" },
  { id: 4, name: "Level 4" },
];
const buildingOptions = [
  { id: 1, name: "Building 1" },
  { id: 2, name: "Building 2" },
  { id: 3, name: "Building 3" },
  { id: 4, name: "Building 4" },
];
const unitOptions = [
  { id: 1, name: "Suite001" },
  { id: 2, name: "Suite002" },
  { id: 3, name: "Suite003" },
  { id: 4, name: "Suite004" },
];

class PropertyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonPressed: "",
      selectedFloorValues: [],
      selectedBuildings: [],
      selectedUnitValues: [],

      buildingOptions: [],
      levelsOptions: [],
      unitOptions: [],

      plan: "buildings",
      isPresentProperty: true,

      floorSelectAll: false,
      buildingSelectAll: false,
      unitSelectAll: false,
      description: this.props.announcementFormData?.description,
    };
    

  }

  onEditorChange = (editorState) => {    
    
    this.setState({ description: editorState }, () => {
      this.props.onSetAnnouncementFormData({
        description: editorState
      })
    })
  } 

  componentDidMount() {
    const { onStopFormLoading, user, onFetchProperties } =
      this.props;
    onFetchProperties(user.id, user.roles[0].role.name);

    onStopFormLoading();
  }

  setBuildingsOnload() {
    if (this.props.announcementFormData.propertyId) {
      this.onChangeProperty(this.props.announcementFormData.propertyId);
    }
    this.setState({
      isPresentProperty: false,
    });
  }

  validatePropertyForm() {
    const { onClose, onSaveAnnouncements, announcementFormData } = this.props;
    // let errors={}

    // this.setState({errors})
    // if(!errors.errors){

    onSaveAnnouncements(announcementFormData);
    // }
  }
  onSelectAttachments = (files) => {
    const { announcementFormData, onSetAnnouncementFormData } = this.props;
    if (
      announcementFormData.attachments &&
      announcementFormData.attachments.length > 0
    ) {
      let attachment = announcementFormData.attachments;
      for (var i = 0; i < attachment.length; i++) {
        if (attachment[i].id) {
        } else {
          for (var j = 0; j < files.length; j++) {
            if (files[j].name === attachment[i].name) {
              files.splice(j, 1);
            }
          }
        }
      }
      onSetAnnouncementFormData({ attachments: [...files, ...attachment] });
    } else {
      onSetAnnouncementFormData({ attachments: files });
    }
  };

  handleDelete(item) {
    const { announcementFormData, onSetAnnouncementFormData } = this.props;
    let attachments = announcementFormData.attachments;

    let deletedFiles = announcementFormData.deletedFiles
      ? announcementFormData.deletedFiles
      : [];
    if (item.id) {
      item = { ...item, isDeleted: true };
      deletedFiles = [item, ...deletedFiles];
    }
    attachments = announcementFormData.attachments.filter((data) =>
      data && data.id ? data.id !== item.id : data !== item
    );
    onSetAnnouncementFormData({ attachments, deletedFiles });
  }
  selectAllFloors = () => {
    if (!this.state.floorSelectAll) {
      this.setState({
        selectedFloorValues: this.state.levelsOptions,
        floorSelectAll: !this.state.floorSelectAll,
      });
      const obj = {
        PropertyId: this.props.announcementFormData.propertyId,
        Type: "Levels",
        BuildingLevels: this.state.levelsOptions.map((item) => {
          return {
            Id: item.id,
          };
        }),
      };
      client.getAnnouncementUnits(obj).then((response) => {
        if (response.ok || response.status === 200) {
          // console.log(response, 'response building');
          this.props.onSetAnnouncementFormData({
            "IsBuilding":false,
            "IsLevel":true,
            "AnnouncementBuildingLevels":this.state.levelsOptions.map((item) => {
                      return {
                         BuildingLevelId: item.id,
                    };
        }),
          })
          response.json().then((responseJson) => {
            const data = responseJson.map((item) => {
              if(item.name !==null)
              return {
                id: item.unitId,
                name: item.name,
              };
            });
            this.setState({ unitOptions: data.filter(item=>item!==undefined) });
          });
        }
      });
    } else {
      this.setState({
        selectedFloorValues: null,
        floorSelectAll: !this.state.floorSelectAll,
        unitOptions: [],
      });
    }
  };
  selectAllBuildings = () => {
    if (!this.state.buildingSelectAll) {
      this.setState({
        selectedBuildings: this.state.buildingOptions,
        buildingSelectAll: !this.state.buildingSelectAll,
      });
      const obj = {
        PropertyId: this.props.announcementFormData.propertyId,
        Type: "Building",
        BuildingLevels: this.state.buildingOptions.map((item) => {
          return {
            Id: item.id,
          };
        }),
      };
      client.getAnnouncementUnits(obj).then((response) => {
        if (response.ok || response.status === 200) {
          // console.log(response, 'response building');
          this.props.onSetAnnouncementFormData({
            "IsBuilding":true,
            "IsLevel":false,
            "AnnouncementBuildingLevels":this.state.buildingOptions.map((item) => {
                      return {
                         BuildingLevelId: item.id,
                    };
        }),
          })
          response.json().then((responseJson) => {
            const data = responseJson.map((item) => {
              return {
                id: item.unitId,
                name: item.name,
              };
            });
            this.setState({ unitOptions: data });
          });
        }
      });
    } else {
      
      this.setState({
        buildingSelectAll: !this.state.buildingSelectAll,
        unitOptions: [],
        selectedBuildings: [],
      });
      
    }
  };

  selectAllUnits = () => {
    if (!this.state.unitSelectAll) {
      this.setState({
        selectedUnitValues: this.state.unitOptions,
        unitSelectAll: !this.state.unitSelectAll,
      });
      this.props.onSetAnnouncementFormData({
        AnnouncementSuites: this.state.unitOptions.map((item) => {
          return { UnitId: item.id };
        }),
      });
    } else {
      this.setState({
        selectedUnitValues: [],
        unitSelectAll: !this.state.unitSelectAll,
      });
      this.props.onSetAnnouncementFormData({
        AnnouncementSuites: [],
      });
    }
  };
  onSelectUnits = (selectedList, selectedItem) => {
    this.setState({ selectedUnitValues: selectedList });
    this.props.onSetAnnouncementFormData({
      AnnouncementSuites: selectedList.map((item) => {
        return { UnitId: item.id };
      }),
    });
  };
  onRemoveUnits = (selectedList, removedItem) => {
    this.setState({ selectedUnitValues: selectedList });
    this.props.onSetAnnouncementFormData({
      AnnouncementSuites: selectedList.map((item) => {
        return { UnitId: item.id };
      }),
    });
  };
  onSelectFloor = (selectedList, selectedItem) => {
    this.setState({ selectedFloorValues: selectedList });
    const obj = {
      PropertyId: this.props.announcementFormData.propertyId,
      Type: "Levels",
      BuildingLevels: selectedList.map((item) => {
        return {
          Id: item.id,
        };
      }),
    };
    client.getAnnouncementUnits(obj).then((response) => {
      if (response.ok || response.status === 200) {
        // console.log(response, 'response building');
        this.props.onSetAnnouncementFormData({
          "IsBuilding":false,
          "IsLevel":true,
          "AnnouncementBuildingLevels":selectedList.map((item) => {
                    return {
                       BuildingLevelId: item.id,
                  };
      }),
        })
        response.json().then((responseJson) => {
          const data = responseJson.map((item) => {
            return {
              id: item.unitId,
              name: item.name,
            };
          });
          this.setState({ unitOptions: data });
        });
      }
    });
  };
  onRemoveFloor = (selectedList, removedItem) => {
    this.setState({ selectedFloorValues: selectedList });
    const obj = {
      PropertyId: this.props.announcementFormData.propertyId,
      Type: "Levels",
      BuildingLevels: selectedList.map((item) => {
        return {
          Id: item.id,
        };
      }),
    };
    client.getAnnouncementUnits(obj).then((response) => {
      if (response.ok || response.status === 200) {
        // console.log(response, 'response building');
        this.props.onSetAnnouncementFormData({
          "IsBuilding":false,
          "IsLevel":true,
          "AnnouncementBuildingLevels":selectedList.map((item) => {
                    return {
                       BuildingLevelId: item.id,
                  };
      }),
        })
        response.json().then((responseJson) => {
          const data = responseJson.map((item) => {
            return {
              id: item.unitId,
              name: item.name,
            };
          });
          this.setState({ unitOptions: data });
        });
      }
    });
  };
  onSelectBuildings = async (selectedList, selectedItem) => {
    this.setState({ selectedBuildings: selectedList });

    const obj = {
      PropertyId: this.props.announcementFormData.propertyId,
      Type: "Building",
      BuildingLevels: selectedList.map((item) => {
        return {
          Id: item.id,
        };
      }),
    };
    await client.getAnnouncementUnits(obj).then((response) => {
      if (response.ok || response.status === 200) {
        // console.log(response, 'response building');
        this.props.onSetAnnouncementFormData({
          "IsBuilding":true,
          "IsLevel":false,
          "AnnouncementBuildingLevels":selectedList.map((item) => {
                    return {
                       BuildingLevelId: item.id,
                  };
      }),
        })
        response.json().then((responseJson) => {
          const data = responseJson.map((item) => {
            return {
              id: item.unitId,
              name: item.name,
            };
          });
          this.setState({ unitOptions: data });
        });
      }
    });
  };
  onRemoveBuildings = (selectedList, removedItem) => {
    this.setState({ selectedBuildings: selectedList });
    const obj = {
      PropertyId: this.props.announcementFormData.propertyId,
      Type: "Building",
      BuildingLevels: selectedList.map((item) => {
        return {
          Id: item.id,
        };
      }),
    };
    client.getAnnouncementUnits(obj).then((response) => {
      if (response.ok || response.status === 200) {
        this.props.onSetAnnouncementFormData({
          "IsBuilding":true,
          "IsLevel":false,
          "AnnouncementBuildingLevels":selectedList.map((item) => {
                    return {
                       BuildingLevelId: item.id,
                  };
      }),
        })
        // console.log(response, 'response building');
        response.json().then((responseJson) => {
          const data = responseJson.map((item) => {
            return {
              id: item.unitId,
              name: item.name,
            };
          });
          this.setState({ unitOptions: data });
        });
      }
    });
  };
  componentDidUpdate() {
    const {
      validation,
      onClose,
      onClearAnnouncementFormData,
      clearValidation,
      announcementFormData,
    } = this.props;
    if (validation.status === true) {
      if (
        validation.message === "Success" &&
        this.state.buttonPressed === "SaveAndClose"
      ) {
        onClose();
        onClearAnnouncementFormData();
        clearValidation();
      } else if (
        validation.message === "Success" &&
        this.state.buttonPressed === "SaveAndAdd"
      ) {
        onClearAnnouncementFormData();
        clearValidation();
        this.setState({ description: ""})
      }
    }
  }


  onChangeProperty(propertyId) {
    // console.log(propertyId, 'propertyId');
    this.setState({
      selectedBuildings:[],
      selectedFloorValues:[],
      selectedUnitValues:[]
    })
    client.getAnnouncementBuildings(propertyId).then((response) => {
      if (response.ok || response.status === 200) {
        // console.log(response, 'response building');
        response.json().then((responseJson) => {
          //  console.log(responseJson, 'data');
          const data = responseJson.map((item) => {
            if(item.building !==null)
            return {
              id: item.id,
              name: item.building === null ? "" : item.building,
            };
          });
         
          this.setState({ buildingOptions: data.filter(item=>item!==undefined) });
        });
      }
    });
    client.getAnnouncementLevels(propertyId).then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responseJson) => {
          // console.log(responseJson, 'data');
          const data = responseJson.map((item) => {
            if(item.level !==null)
            return {
              id: item.id,
              name: item.level === null ? "" : item.level,
            };
          });
          this.setState({ levelsOptions: data.filter(item=>item!==undefined) });
        });
      }
    });
  }

  render() {
    const {
      onClose,
      onSetAnnouncementFormData,
      announcementFormData,
      user,
      loader,
    } = this.props;
    const description = convertHTMLToString(announcementFormData.description);
    let condition =
      announcementFormData &&
      announcementFormData.title &&
      announcementFormData.title.trim() &&
      announcementFormData &&
      description &&
      // announcementFormData.description &&

      // announcementFormData.description.trim() &&
      announcementFormData.propertyId;

    this.state.isPresentProperty && this.setBuildingsOnload();
    //Modified By: Anjali
    //Modified On: 10-10-2023
    //Jira-Id: https://bosframework.atlassian.net/browse/JUN-3692
    //Reason: Change the button from ‘SAVE ANNOUNCEMENT’ to SEND ANNOUNCEMENT and the ‘SAVE AND ADD ANOTHER’ to SEND AND ADD ANOTHER.
    return (
      <Form
        headline={
          (announcementFormData.id ? "Edit" : "Add an") + " Announcement"
        }
        onClose={onClose}
        onSubmit={() => this.validatePropertyForm()}
        actions={
          <>
            {loader ? <Loader center={true} /> : null}
            {!announcementFormData.id ? (
              <Button
                color="semantic"
                size="small"
                label="Send and Add Another"
                onClick={() =>
                  this.setState({
                    buttonPressed: "SaveAndAdd",
                    selectedFloorValues: [],
                    selectedBuildings: [],
                    selectedUnitValues: [],

                    plan: "buildings",
                    buildingOptions: [],
                    levelsOptions: [],
                    unitOptions: [],
                  })
                }
                disabled={!condition}
              />
            ) : (
              <div />
            )}
            <Button
              color="teal"
              size="small"
              label="Send Announcement"
              onClick={() =>
                this.setState({
                  buttonPressed: "SaveAndClose",
                })
              }
              disabled={!condition}
            />
          </>
        }
        component={
          <>
            <Heading>Announcement Details</Heading>
            <Row>
              <Col xs="12" md="6">
                <Select
                  value={
                    announcementFormData.propertyId
                      ? announcementFormData.propertyId
                      : ""
                  }
                  onChange={(e) => {
                    onSetAnnouncementFormData({ propertyId: e.target.value });
                    this.onChangeProperty(e.target.value);
                  }}
                  options={this.props.properties.map((property) => ({
                    value: property.propertyId,
                    label: property.name,
                  }))}
                  label="Property"
                  placeholder="Property"
                  block
                />
                <Row>
                  <Col
                    xs="12"
                    md="3"
                  >                   
                    <label for="Building" style={{ padding: "0px 20px 0px 5px" }}>
                    <Checkbox
                      id="Buildings"
                      name="plan"
                      value={this.state.plan === "buildings"?this.state.plan:''}
                      checked={this.state.plan === "buildings"}
                      onChange={(e) => {
                        this.setState({ plan: 'buildings' });
                        console.log('e.target.value',e.target.value)
                      }}
                    />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Buildings
                    </label>
                  </Col>
                 <Col
                    xs="12"
                    md="6"
                  > 
                  <label for="Floor" style={{ padding: "0px 20px 0px 5px" }}>
                  <Checkbox
                    id="Floor/Level"
                    name="plan"
                    value={this.state.plan === "floor"?this.state.plan:''}
                    checked={this.state.plan === "floor"}
                    onChange={(e) => {
                      this.setState({ plan: 'floor' });
                      console.log('e.target.value',e.target.value)
                    }}
                  />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Floor/Level
                  </label>
                  </Col>
                </Row>
                {this.state.plan === "buildings" && (
                  <div>
                    <div style={{ display: "flex", alignItems: "center", marginTop: "10px"}}>
                      <div
                        className="reporting__heading"
                        style={{ color: "black" }}
                      >
                        Buildings
                      </div>

                      <div className="picker__required"></div>
                    </div>
                    {this.state.buildingOptions.length !== 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "-20px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={this.state.buildingSelectAll}
                          onChange={() => {
                            this.selectAllBuildings();
                          }}
                        />{" "}
                        Select All
                      </div>
                    )}

                    <Multiselect
                      id="building"
                      options={this.state.buildingOptions}
                      displayValue="key"
                      selectedValues={this.state.selectedBuildings}
                      displayValue="name"
                      placeholder="Select Buildings"
                      // onChange={()=>{}}
                      disable={this.state.buildingOptions.length === 0}
                      onSelect={this.onSelectBuildings}
                      onRemove={this.onRemoveBuildings}
                    />
                  </div>
                )}
                {this.state.plan === "floor" && (
                  <div>
                    <div style={{ display: "flex", alignItems: "center", marginTop: "10px"}}>
                      <div
                        className="reporting__heading"
                        style={{ color: "black" }}
                      >
                        Floor/Level
                      </div>

                      <div className="picker__required" />
                    </div>
                    {this.state.levelsOptions.length !== 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "-20px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={this.state.floorSelectAll}
                          onChange={() => {
                            this.selectAllFloors();
                          }}
                        />{" "}
                        Select All
                      </div>
                    )}
                    <Multiselect
                      id="level"
                      options={this.state.levelsOptions}
                      displayValue="key"
                      selectedValues={this.state.selectedFloorValues}
                      displayValue="name"
                      placeholder="Select Floor"
                      disable={this.state.levelsOptions.length === 0}
                      onSelect={this.onSelectFloor}
                      onRemove={this.onRemoveFloor}
                      // style={{height: 300, chips: { background: "red" }, searchBox: { border: "none", "border-bottom": "1px solid blue", "border-radius": "0px" } }}
                    />
                  </div>
                )}
                <br />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    className="reporting__heading"
                    style={{ color: "black" }}
                  >
                    Unit(s)
                  </div>
                  <div className="picker__required" />
                </div>
                {this.state.unitOptions.length !== 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "-20px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={this.state.unitSelectAll}
                      onChange={() => {
                        this.selectAllUnits();
                      }}
                    />{" "}
                    Select All
                  </div>
                )}
                <Multiselect
                  options={this.state.unitOptions}
                  displayValue="key"
                  selectedValues={this.state.selectedUnitValues}
                  displayValue="name"
                  placeholder="Select Units"
                  disable={this.state.unitOptions.length === 0}
                  onSelect={this.onSelectUnits}
                  onRemove={this.onRemoveUnits}
                  // style={{height: 300, chips: { background: "red" }, searchBox: { border: "none", "border-bottom": "1px solid blue", "border-radius": "0px" } }}
                />
                <br />
              </Col>
              <Col xs="12" md="6">
                <Input
                  value={announcementFormData.title}
                  onChange={(e) =>
                    onSetAnnouncementFormData({ title: e.target.value })
                  }
                  label="Title"
                  required
                  placeholder="eg., Title"
                  block
                />
                
                <div className="input">
                  <div className="input__require">
                    <label className="input__label">Description</label>
                    <div className="input__required" />
                  </div>

                  <div class style={{borderBottom: '0.1rem solid rgba(83, 83, 83, 0.25)'}} className="input__control">
                   
                <TextEditor
                    editorState={this.state.description}
                    onEditorStateChange={this.onEditorChange}
                />
                </div>
                </div>

                <File
                  label="Attachments"
                  onSelect={(file) => onCheckHeicDocument(file) && this.onSelectAttachments(file)}
                  files={[]}
                  multiSelect={true}
                  type={['image', 'pdf']}
                />

                {announcementFormData.attachments &&
                announcementFormData.attachments.length > 0
                  ? announcementFormData.attachments.map((data, i) =>
                      data.id && data.isDeleted === true ? null : (
                        <Row mdCenter>
                          <Col granola xs="11" md="9">
                            {data && data.path ? data.path : data.name}
                          </Col>

                          <Col granola xs="1" md="1">
                            <div onClick={() => this.handleDelete(data)}>
                              <Icon
                                glyph="times-circle"
                                weight="light"
                                size="small"
                              />
                            </div>
                          </Col>
                        </Row>
                      )
                    )
                  : null}
              </Col>
            </Row>
          </>
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  announcementFormData: selectAnnouncementFormData(state),
  properties: selectProperties(state),
  user: selectAuthenticatedUser(state),
  validation: selectValidation(state),
  loader: selectFormLoader(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchProperties: fetchProperties,
      onSetAnnouncementFormData: setAnnouncementFormData,
      onClearAnnouncementFormData: clearAnnouncementFormData,
      clearValidation: clearValidation,
      onStopFormLoading: stopFormLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PropertyForm);
